import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import installElementPlus from './plugins/element'
// import installSwiper from './plugins/swiper'

document.addEventListener('contextmenu', function(event) {
	event.preventDefault(); // 阻止右键菜单的默认行为
});

router.beforeEach((to, from, next) => {
    const userInfo = store.checkLogin()
    const publicRoutes = ['login', 'login_test', 'login_ewm', 'bind_ewm', 'introduct', 'login_reset', 'reset_success', 'login_findPwd']
    if (!userInfo && !publicRoutes.includes(to.name)) {
        return next({ name: 'login', params: { from_path: to.fullPath, from_name: to.name } })
    }
    if (userInfo) {
        if (to.meta.permission && userInfo['permission']) {
            if (userInfo['permission'].split(',').indexOf('' + to.meta.permission) === -1) {
                return next({ name: 'login' })
            }
        }
        if (to.meta.role && userInfo['role']) {
            if (to.meta.role != userInfo['role']) {
                return next({ name: 'login' })
            }
        }
    }
    next()
});
const app = createApp(App)
installElementPlus(app)
// 全局level变量 1 性能 2功能 3旅途
app.config.globalProperties.$levelId = {
    performance: 4227,
    function: 4921,
    trip: 4574,
    drive_function: 4921,
    function2: 4921
}
// installSwiper(app)
app.use(store).use(router).use(VueAxios, axios).mount('#app')